import React from 'react'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { useSteadyVisible } from './use-steady-visible'
import { Bar } from './top-loading-bar.style'

/**
 * The app-wide "something is loading" indicator, replacing the old MUI
 * `LinearProgress` that flashed on screen for every request. It reads
 * `loadingStore.global` through `active`; `useSteadyVisible` is what keeps a
 * quick request from ever drawing it and a burst of them from making it stutter.
 */
export const TopLoadingBar = ({ active }) => {
	const { t } = useTranslation()
	const visible = useSteadyVisible(active)

	return <Bar $visible={visible} role="progressbar" aria-label={t('LOADING')} aria-hidden={!visible} />
}
